<template>
  <div class="basic-fields">
    <el-table :data="settingsData" border>
      <el-table-column
        prop="displayName"
        label="参数项"
        width="200"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column label="参数值" :resizable="false">
        <template slot-scope="scope">
          <span
            v-for="(item, index) in scope.row.value"
            :key="index"
            class="setting-value"
            :class="{ 'setting-default': item.isDefault }"
          >
            {{ item.option
            }}<span v-if="index != scope.row.value.length - 1">、</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="60" :resizable="false" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="edit(scope.row)">修改</el-button>
        </template>
      </el-table-column>
      <template slot="empty">
        <div class="loading-box" v-if="isLoading">
          <img
            src="../../../../assets/image/loading.png"
            alt="loading"
            class="loading-ico"
          />
          数据加载中...
        </div>
        <div class="empty-box" v-if="!isLoading && !settingsData.length">
          列表为空
        </div>
      </template>
    </el-table>
    <el-dialog
      :title="titleText"
      :visible.sync="isEditSetting"
      class="setting-dialog"
    >
      <div class="tip-box">
        <i class="el-icon-warning"></i>
        注意，调整该选择会同时调整目前已使用该选择的员工/部门相关数据，请谨慎操作。
      </div>
      <el-table
        :data="settingData"
        border
        class="setting-table"
        row-key="index"
      >
        <el-table-column label="选项值" :resizable="false">
          <template slot-scope="scope">
            <el-input
              :class="{ 'error-input': scope.row.error }"
              v-model="scope.row.option"
              placeholder="请输入选项值名称"
              @blur="settingBlur(scope.row)"
              @change="settingChange(scope.row)"
              :disabled="scope.row.isDefault"
              clearable
            ></el-input>
            <span class="rule-tip" v-if="scope.row.error"
              >*请输入选项值名称</span
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" width="135" :resizable="false">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="moveUp(scope.$index)"
              v-if="scope.$index != 0"
              >上移</el-button
            >
            <el-button
              type="text"
              @click="moveDown(scope.$index)"
              v-if="scope.$index != settingData.length - 1"
              >下移</el-button
            >
            <!-- <el-button
              type="text"
              class="del-btn"
              @click="deleteSetting(scope.$index)"
              v-if="!scope.row.isDefault"
              >删除</el-button
            > -->
            <el-popover placement="bottom" trigger="click">
              <el-button
                @click.native.prevent="deleteSetting(scope.$index)"
                type="text"
                class="del-btn"
                >删除</el-button
              >
              <el-button slot="reference" type="text" class="more-btn" v-if="!scope.row.isDefault"
                >更多</el-button
              >
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <div class="add-setting" @click="addSetting">
          <i class="el-icon-plus"></i>添加选项值
        </div>
        <div>
          <el-button @click="isEditSetting = false">取 消</el-button>
          <el-button type="primary" @click="submitEditSetting">确 定</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUserSettings,
  updateUserSettings,
  getOuSettings,
  updateOuSettings,
} from "@/http/api/system";
import { deepCopy } from "@/utils/deepCopy";
import Sortable from "sortablejs";
export default {
  data() {
    return {
      titleText: "",
      isLoading:true,
      isEditSetting: false,
      settingsData: [],
      settingData: [],
      orgSettings: [],
      userSettings: [],
      settingName: "",
      permissions: this.$store.getters.permissions,
    };
  },
  mounted() {
    this.getSettingsData();
    // 阻止默认行为
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
  },
  methods: {
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector(
        ".setting-table .el-table__body-wrapper tbody"
      );
      //console.log(tbody, "tbody");
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const targetRow = _this.settingData.splice(oldIndex, 1)[0];
          _this.settingData.splice(newIndex, 0, targetRow);
        },
      });
    },
    // 删除
    deleteSetting(i) {
      this.settingData.splice(i, 1);
    },
    // 下移
    moveDown(i) {
      this.swapItems(this.settingData, i, i + 1);
    },
    // 上移
    moveUp(i) {
      this.swapItems(this.settingData, i, i - 1);
    },
    // 数组内交换位置
    swapItems(arr, index1, index2) {
      arr[index1] = arr.splice(index2, 1, arr[index1])[0];
    },
    // 修改
    edit(v) {
      this.titleText = "修改" + v.displayName;
      let arr = deepCopy(v.value);
      if (arr) {
        arr.map((el, index) => {
          el.error = false;
          el.index = index;
        });
      } else {
        arr = [];
      }
      this.settingData = arr;
      this.settingName = v.name;
      this.isEditSetting = true;
      this.$nextTick(() => {
        this.rowDrop();
      });
    },
    // 获取基础字段
    getSettingsData() {
      this.userSettings = []
      getUserSettings().then((res) => {
        res.result.map(item=>{
          if(item.isCollection){
            this.userSettings.push(item)
          }
        })
        this.getOuSettings();
      });
    },
    getOuSettings() {
      this.orgSettings = []
      getOuSettings().then((res) => {
        res.result.map(item=>{
          if(item.isCollection){
            this.orgSettings.push(item)
          }
        })
        this.settingsData = this.userSettings.concat(this.orgSettings);
        this.isLoading = false;

      });
    },
    // 提交修改设置项
    submitEditSetting() {
      if (this.permissions["System.UserSettings.Update"]) {
      let status = this.settingData.some((el) => {
        return el.option.trim() == "";
      });
      let valueArr = [];
      this.settingData.map((el) => {
        if (!el.option.trim()) {
          el.error = true;
        }
        valueArr.push(el.option);
      });
      if (!status) {
        let data = {
          settings: [
            {
              name: this.settingName,
              value: valueArr.join("|"),
              isCollection: true,
              forceToSet: true,
            },
          ],
        };
        if (this.settingName.split(".")[1] == "OrganizationUnit") {
          updateOuSettings(
            this.$store.getters.generateUpdateSettingsParams,
            data
          ).then((res) => {
            if (res) {
              this.$message.success({
                message: `修改成功`,
                showClose: true,
              });
            }
            this.getSettingsData()
            this.isEditSetting = false;
          });
        } else {
          updateUserSettings(
            this.$store.getters.generateUpdateSettingsParams,
            data
          ).then((res) => {
            if (res) {
              this.$message.success({
                message: `修改成功`,
                showClose: true,
              });
            }
            this.getSettingsData()
            this.isEditSetting = false;
          });
        }
      }
      } else {
        this.$message.warning({
          message: `您暂无更新设置权限`,
          showClose: true,
        });
      }
    },
    addSetting() {
      this.settingData.push({
        isDefault: false,
        error: false,
        option: "",
      });
    },
    settingBlur(v) {
      if (!v.option.trim()) {
        v.error = true;
      }
    },
    settingChange(v) {
      if (v.option.trim()) {
        v.error = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.basic-fields {
  padding: 20px;
  background: #fff;
  ::v-deep .el-table {
    .el-table__header {
      th {
        background-color: #f2f2f2;
      }

      th {
        padding: 7px 0;
      }
    }

    td {
      padding: 7px 0;
    }

    .el-table__row {
      .cell {
        .setting-value {
          color: #000;
        }

        .setting-default {
          color: #888;
        }
      }
    }
  }

  .setting-dialog {
    ::v-deep .el-dialog__body {
      overflow-y: auto;
      margin-right: 0;
      padding-right: 20px;
      max-height: calc(100vh - 250px);

      .tip-box {
        margin-bottom: 16px;
        border: 1px solid rgb(254, 229, 143);
        padding: 8px 16px;

        font-size: 12px;
        color: rgb(51, 51, 51);
        background-color: rgb(255, 251, 230);

        i {
          font-size: 14px;
          vertical-align: middle;
          color: rgb(247, 186, 42);
        }
      }

      .el-table {
        .el-input {
          width: 180px;

          &.error-input {
            .el-input__inner {
              border-color: #f56c6c !important;
            }
          }
        }

        .rule-tip {
          margin-left: 5px;
          color: #f56c6c;
        }
      }
    }

    .dialog-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .add-setting {
        color: $--color-primary;
        cursor: pointer;

        i {
          margin-right: 2px;
        }
      }
    }
  }
}
</style>